import styled from "styled-components";
import { Modal as AntModal } from "antd";
import { SpinBonusBg } from "@assets";

export const Modal = styled(AntModal)`
	/* position: relative; */
	.ant-modal-content {
		border: none !important;
		background-image: url(${SpinBonusBg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		width: 365px !important;
		height: 423px !important;
		/* height: 3px; */
		box-shadow: none !important;
		background-color: transparent !important;
	}
	@media screen and (max-width: 413px) {
		width: 265px !important;
		height: 323px !important;
		.ant-modal-content {
			width: 265px !important;
			height: 323px !important;
		}
	}
`;

export const ModalTitle = styled.p`
	margin-top: 160px;

  color: #13100F;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
	@media screen and (max-width: 413px) {
		margin-top: 110px;
		font-size: 18px;
		font-weight: 500;
		line-height: 25px;
	}
`;

export const ModalLabel = styled.p`
	margin-top: 20px;

  color: #13100F;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
	@media screen and (max-width: 413px) {
    margin-top: 12px ;
		font-weight: 300;
		font-size: 10px;
		line-height: 20px;
	}
`;

export const AmountWrapper = styled.div`
  color:  #13100F;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (max-width: 413px) {
		font-weight: 500;
		font-size: 10px;
		line-height: 18px;
	}
`;

export const OkWrapper = styled.div`
	width: 238px;
	height: 39px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
  border-radius: 12px;
  background: #482701;
	cursor: pointer;

  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
	@media screen and (max-width: 413px) {
		width: 150px !important;
		height: 30px !important;
		margin-top: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
	}
`;

export const ExpiredText = styled.div`
  margin: 28px 0 0 0;

  color: #13100F;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
	@media screen and (max-width: 413px) {
		margin-top: 20px;
		font-size: 8px;
		font-weight: 200;
		line-height: 15px;
	}
`;

export const ExpiredDate = styled.span`
  color: #13100F;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
